import { IClassname } from '@/lib/shared/model/classname';

export const Wifi = ({ className }: IClassname) => {
  return (
    <svg
      className={className}
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.6338 7.36523C18.9931 7.7247 19.195 8.21217 19.195 8.72046C19.195 9.22876 18.9931 9.71623 18.6338 10.0757"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.3442 4.65332C21.8783 5.18732 22.3018 5.82126 22.5908 6.51896C22.8798 7.21667 23.0285 7.96447 23.0285 8.71965C23.0285 9.47484 22.8798 10.2226 22.5908 10.9203C22.3018 11.618 21.8783 12.252 21.3442 12.786"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.3442 4.65332C21.8783 5.18732 22.3018 5.82126 22.5908 6.51896C22.8798 7.21667 23.0285 7.96447 23.0285 8.71965C23.0285 9.47484 22.8798 10.2226 22.5908 10.9203C22.3018 11.618 21.8783 12.252 21.3442 12.786"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24.0508 1.94336C24.9409 2.83336 25.6469 3.88997 26.1285 5.05284C26.6103 6.21572 26.8582 7.46209 26.8582 8.72079C26.8582 9.97949 26.6103 11.2259 26.1285 12.3887C25.6469 13.5516 24.9409 14.6083 24.0508 15.4982"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24.0508 1.94336C24.9409 2.83336 25.6469 3.88997 26.1285 5.05284C26.6103 6.21572 26.8582 7.46209 26.8582 8.72079C26.8582 9.97949 26.6103 11.2259 26.1285 12.3887C25.6469 13.5516 24.9409 14.6083 24.0508 15.4982"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.3662 7.36523C13.0068 7.7247 12.8049 8.21217 12.8049 8.72046C12.8049 9.22876 13.0068 9.71623 13.3662 10.0757"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.6558 4.65332C10.1218 5.18732 9.69819 5.82126 9.40919 6.51896C9.12018 7.21667 8.97144 7.96447 8.97144 8.71965C8.97144 9.47484 9.12018 10.2226 9.40919 10.9203C9.69819 11.618 10.1218 12.252 10.6558 12.786"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.6558 4.65332C10.1218 5.18732 9.69819 5.82126 9.40919 6.51896C9.12018 7.21667 8.97144 7.96447 8.97144 8.71965C8.97144 9.47484 9.12018 10.2226 9.40919 10.9203C9.69819 11.618 10.1218 12.252 10.6558 12.786"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.94906 1.94336C7.05899 2.83336 6.35295 3.88997 5.87124 5.05284C5.38953 6.21572 5.1416 7.46209 5.1416 8.72079C5.1416 9.97949 5.38953 11.2259 5.87124 12.3887C6.35295 13.5516 7.05899 14.6083 7.94906 15.4982"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.94906 1.94336C7.05899 2.83336 6.35295 3.88997 5.87124 5.05284C5.38953 6.21572 5.1416 7.46209 5.1416 8.72079C5.1416 9.97949 5.38953 11.2259 5.87124 12.3887C6.35295 13.5516 7.05899 14.6083 7.94906 15.4982"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M30.696 24.9457C30.696 25.6235 30.4268 26.2735 29.9474 26.7529C29.4681 27.2322 28.818 27.5015 28.1402 27.5015H3.85979C3.18194 27.5015 2.53185 27.2322 2.05255 26.7529C1.57323 26.2735 1.30396 25.6235 1.30396 24.9457V22.3898C1.30396 21.712 1.57323 21.0619 2.05255 20.5826C2.53185 20.1032 3.18194 19.834 3.85979 19.834H28.1402C28.818 19.834 29.4681 20.1032 29.9474 20.5826C30.4268 21.0619 30.696 21.712 30.696 22.3898V24.9457Z"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.73501 23.9866C6.55856 23.9866 6.41553 23.8436 6.41553 23.6671C6.41553 23.4907 6.55856 23.3477 6.73501 23.3477"
        stroke="#22364A"
        strokeWidth="1.33"
      />
      <path
        d="M6.73511 23.9866C6.91155 23.9866 7.05459 23.8436 7.05459 23.6671C7.05459 23.4907 6.91155 23.3477 6.73511 23.3477"
        stroke="#22364A"
        strokeWidth="1.33"
      />
      <path
        d="M11.2079 23.9866C11.0315 23.9866 10.8884 23.8436 10.8884 23.6671C10.8884 23.4907 11.0315 23.3477 11.2079 23.3477"
        stroke="#22364A"
        strokeWidth="1.33"
      />
      <path
        d="M11.2078 23.9866C11.3842 23.9866 11.5272 23.8436 11.5272 23.6671C11.5272 23.4907 11.3842 23.3477 11.2078 23.3477"
        stroke="#22364A"
        strokeWidth="1.33"
      />
      <path
        d="M16 19.8339V13.4443"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.77674 27.501L3.85986 30.0568"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M26.2234 27.501L28.1403 30.0568"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
